//	Note: this is in an external file, as it can sometimes be regenerated (via WebPack), causing an error: "browser.js:49 Warning: You cannot change <Router history>"
//  Ref: https://github.com/gatsbyjs/gatsby/blob/3850103793dbd22f6efcfb5035c682da1f319018/packages/gatsby/cache-dir/dev-history.js
//  Ref: https://github.com/gatsbyjs/gatsby/issues/1966
import { createBrowserHistory } from 'history'

export default createBrowserHistory()



// WEBPACK FOOTER //
// ./src/utilities/CreateHistory.js